import React, { useEffect, useState, useRef } from 'react'
import UserRightsForm from './UserRightsForm'
import * as services from '../../services'
import { useDispatch } from 'react-redux'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
const SUPERUSER = 'SUPERUSER'
export const RequestLocationRights = ({ user }) => {
  const formRef = useRef()
  const dispatch = useDispatch()
  const [isRequestInProgress, setIsRequestInProgress] = useState(false)
  const [enableUserSelection, setEnableUserSelection] = useState(false)

  const requestLocationRights = (values) => {
    const payLoad =
      user.role.toUpperCase() !== SUPERUSER && !values.user
        ? { ...values, user: user.url }
        : { ...values }
    setIsRequestInProgress(true)
    new services.UserRightsService()
      .makePostRequest(payLoad)
      .then((response) => {
        formRef.current.reset()
        dispatch(
          showSuccessToast('Success', 'User rights provisioned successfully')
        )
        setIsRequestInProgress(false)
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
        setIsRequestInProgress(false)
      })
  }
  useEffect(() => {
    setEnableUserSelection(user.role.toUpperCase() === SUPERUSER)
  }, [user])
  return (
    <UserRightsForm
      disabled={isRequestInProgress}
      ref={formRef}
      enableUserSelection={enableUserSelection}
      onSubmit={requestLocationRights}
    />
  )
}
